export default {
	REQUIRED_FIELD: '* Este Campo é obrigatório.',
	EMAIL_INVALID: '* Digite um e-mail válido.',
	URL_INVALID: '* Digite um endereço de url válido.',
	OPEN_FIELD_NEED_VALUE: '* Opção aberta precisa de um valor',
};
